import React, { useEffect, useMemo, useState } from "react";
// import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../redux/searchHotelSlice";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { addDate } from "../redux/cartSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// const { RangePicker } = DatePicker;

const SelectDate = () => {
  const dispatch = useDispatch();
  const selectedDate = useSelector((state) => state.cart.date);
  console.log(selectedDate);

  // Select Date
  // const handleDateChange = (dates) => {
  //   if (dates && dates.length === 2) {
  //     dispatch(
  //       addDate({
  //         checkIn: dates[0].format("YYYY-MM-DD"),
  //         checkOut: dates[1].format("YYYY-MM-DD"),
  //         nights: dates[1].diff(dates[0], "days"),
  //       })
  //     );
  //   } else {
  //     dispatch(addDate({ checkIn: null, checkOut: null, nights: 0 }));
  //   }
  // };

  // Disabled Dates
  // const isDisabled = (current) => {
  //   if (!current) return false;
  //   return current.isBefore(moment().startOf("day"));
  // };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = () => {
    if (startDate && endDate) {
      const checkIn = formatDate(startDate);
      const checkOut = formatDate(endDate);

      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      dispatch(
        addDate({
          checkIn,
          checkOut,
          nights,
        })
      );
    } else {
      dispatch(addDate({ checkIn: null, checkOut: null, nights: 0 }));
    }
  };

  useEffect(() => {
    handleDateChange();
  }, [startDate, endDate]);

  useEffect(() => {
    if (selectedDate?.checkIn && selectedDate?.checkOut) {
      const checkIn = new Date(selectedDate.checkIn);
      const checkOut = new Date(selectedDate.checkOut);

      if (!isNaN(checkIn) && !isNaN(checkOut)) {
        setStartDate(checkIn);
        setEndDate(checkOut);
      }
    }
  }, []);

  return (
    <div className="form-group search-form-select-date">
      <label htmlFor="">
        <FontAwesomeIcon className="icon" icon={faCalendarDays} />{" "}
        {selectedDate.nights} Night
      </label>

      <DatePicker
        placeholderText="Select Date"
        selectsRange
        startDate={startDate}
        endDate={endDate}
        onChange={(dates) => {
          const [start, end] = dates;
          setStartDate(start);
          setEndDate(end);
        }}
        calendarClassName="custom-calendar-search-hotel"
        isClearable
        minDate={new Date()}
        dateFormat="yyyy/MM/dd"
      />

      {/* <RangePicker
        disabledDate={isDisabled}
        onChange={handleDateChange}
        value={
          selectedDate?.checkIn && selectedDate?.checkOut
            ? [
                moment(selectedDate.checkIn, "YYYY-MM-DD"),
                moment(selectedDate.checkOut, "YYYY-MM-DD"),
              ]
            : null
        }
      /> */}
    </div>
  );
};

export default SelectDate;
